import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import moment from "moment";

import ServiceWithParameter from "./serviceWithParameter";
import RangePickerItem from "../../app/generic/rangePickerItem";

const DateRange = ({
  pickup,
  disabled,
  initialDateTo,
  formItemLayout,
  initialDateFrom,
  getFieldDecorator,
}) => {
  const intl = useIntl();
  const [label, setLabel] = useState();
  const [message, setMessage] = useState();
  const [fieldName, setFieldName] = useState();
  useEffect(() => {
    setLabel(
      intl.formatMessage(
        pickup
          ? {
              id: "consignment.services.pickupRange",
              defaultMessage: "Nakládka",
            }
          : {
              id: "consignment.services.deliveryRange",
              defaultMessage: "Vykládka",
            }
      )
    );
    setMessage(
      pickup
        ? intl.formatMessage({
            id: "consignment.services.emptyPickupRange",
            defaultMessage: "Vyberte datum nakládky!",
          })
        : ""
    );
    setFieldName(pickup ? "pickupRange" : "deliveryRange");
  }, [intl, pickup]);

  return fieldName ? (
    <ServiceWithParameter label={label}>
      <RangePickerItem
        future
        showTime={{
          defaultValue: [
            moment("00:00:00", "HH:mm:ss"),
            moment("23:59:59", "HH:mm:ss"),
          ],
        }}
        message={message}
        disabled={disabled}
        fieldName={fieldName}
        formItemLayout={formItemLayout}
        getFieldDecorator={getFieldDecorator}
        initialDateTo={initialDateTo && moment(initialDateTo)}
        initialDateFrom={initialDateFrom && moment(initialDateFrom)}
      />
    </ServiceWithParameter>
  ) : (
    <></>
  );
};

export default DateRange;
